<template>
  <MaterialCard
    color="green"
    full-width
    :style="`position: sticky; top: ${offsetTop}px; z-index: 10;`"
  >
    <v-tabs>
      <v-tab ripple>
        情報
      </v-tab>
      <v-tab-item>
        <v-card flat>
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="company.id"
                    label="id"
                    disabled
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="company.name"
                    class="purple-input"
                    label="社名"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="company.tel"
                    label="電話番号"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="company.representativeName"
                    label="代表"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="company.headOfficeLocation"
                    label="本社所在地"
                    class="purple-input"
                    readonly
                  />
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="company.address"
                    label="住所"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="company.remarks"
                    class="purple-input"
                    label="備考"
                  />
                </v-flex>
                <v-flex
                  xs12
                  text-xs-right
                >
                  <v-btn
                    class="mx-0"
                    color="success"
                  >
                    更新
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </MaterialCard>
</template>
<script>
import { mapState } from 'vuex'
export default {
  // eslint-disable-next-line
  props: ['company'],
  computed: {
    ...mapState('display', ['offsetTop'])
  }
}
</script>
